import React from "react";
import { motion } from "framer-motion";
import { FaShippingFast, FaUndoAlt, FaWhatsapp } from "react-icons/fa";
import Navbar from "../components/Navbar";

const ShippingReturnPolicy = () => {
  const whatsappNumber = "+923001234567"; // replace with your actual WhatsApp number

  return (
    <>
      <Navbar />

      <div className="min-h-screen bg-gray-50 flex justify-center px-4 py-12 mt-5">
        <motion.div
          className="w-full max-w-5xl bg-white rounded-2xl shadow-xl p-8 md:p-12"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-800 to-pink-500 text-center mb-12">
            Shipping & Return Policies
          </h1>

          {/* Shipping Policy */}
          <div className="grid grid-cols-[64px_1fr] gap-6 mb-12 items-start">
            <div className="flex justify-center pt-1">
              <FaShippingFast className="text-purple-700 text-5xl" />
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">
                Shipping Policy 🚚
              </h2>
              <p className="text-gray-600 leading-relaxed">
                We offer fast and reliable shipping across Pakistan. Orders are
                processed within{" "}
                <span className="font-semibold text-gray-800">
                  1–2 business days
                </span>{" "}
                after confirmation.
                <br /><br />
                Delivery usually takes{" "}
                <span className="font-semibold text-gray-800">
                  3–5 working days
                </span>{" "}
                depending on your city.
                <br /><br />
                Once shipped, a tracking number will be shared via email or SMS.
                Please ensure your address and contact details are accurate.
              </p>
            </div>
          </div>

          {/* Return Policy */}
          <div className="grid grid-cols-[64px_1fr] gap-6 mb-12 items-start">
            <div className="flex justify-center pt-1">
              <FaUndoAlt className="text-pink-600 text-5xl" />
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-3">
                Return & Exchange Policy 🔁
              </h2>
              <p className="text-gray-600 leading-relaxed">
                If you’re not satisfied, you can request a return or exchange
                within{" "}
                <span className="font-semibold text-gray-800">7 days</span> of
                receiving the product.
                <br /><br />
                Items must be unused, in original packaging, and include proof
                of purchase.
                <br /><br />
                Refunds are processed after inspection.{" "}
                <span className="font-semibold text-gray-800">
                  Delivery charges are non-refundable.
                </span>
              </p>
            </div>
          </div>

          {/* WhatsApp CTA */}
          <motion.a
            href={`https://wa.me/${whatsappNumber.replace("+", "")}`}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.05 }}
            className="flex items-center justify-center gap-2 bg-green-500 text-white py-3 px-6 rounded-full shadow-lg mx-auto w-fit"
          >
            <FaWhatsapp className="text-2xl" />
            <span className="font-semibold">Chat with us on WhatsApp</span>
          </motion.a>
        </motion.div>
      </div>
    </>
  );
};

export default ShippingReturnPolicy;
